import { makeAutoObservable } from "mobx";

import { validateTeamAbout, validateTeamPermalink, validateTeamTitle } from "@/models/api/TeamApi";
import { TeamModel } from "@/models/TeamModel";

import type { FormFieldModel } from "@/components/form/FormFieldModel";
import type { TeamFormFields } from "@/models/api/TeamApi";
import type { RootStore } from "@/store/RootStore";

export class UpdateTeamForm implements FormFieldModel<TeamFormFields> {
  private rootStore: RootStore;

  team: TeamModel;

  formFields: FormFieldModel<TeamFormFields>["formFields"] = {
    permalink: {
      value: "",
      focused: false,
      error: null,
      validate: (value) => validateTeamPermalink(value),
    },
    title: {
      value: "",
      focused: false,
      error: null,
      validate: (value) => validateTeamTitle(value),
    },
    about: {
      value: "",
      focused: false,
      error: null,
      validate: (value) => validateTeamAbout(value),
    },
  };

  constructor(rootStore: RootStore, team?: TeamModel) {
    this.rootStore = rootStore;
    if (!team) {
      // eslint-disable-next-line no-param-reassign
      team = new TeamModel(this.rootStore, {
        typename: "TeamShort",
        uid: "",
        title: "",
        bio: null,
        permalink: "",
        personal: false,
        kind: "regular",
        avatarUrls: null,
        followersCount: 0,
        unreadMessagesCount: 0,
        membersCount: 0,
        userPermissions: { read: true, write: true, invite: true, billing: true },
      });
    }
    this.team = team;
    this.formFields.title.value = team.title;
    this.formFields.permalink.value = team.permalink;
    this.formFields.about.value = team.bio || "";

    makeAutoObservable(this);
  }

  async submit() {
    const requestBody = {
      newPermalink: this.formFields.permalink.value,
      title: this.formFields.title.value,
      bio: this.formFields.about.value,
    };
    await this.team.update(requestBody);
  }
}
